import Alpine from 'alpinejs';
import WarmPng from '@images/cta_warm.png?w=600';
import WarmWebp from '@images/cta_warm.png?w=600&format=webp';

document.addEventListener('alpine:init', () => {
  Alpine.data('warm', () => ({
    WarmPng,
    WarmWebp,
  }));
});
